import React from "react";
import { Alarm } from "../../icons";

interface YouWonProps {
  productName?: string;
}

export const YouWon = ({ productName }: YouWonProps) => {
  return (
    <>
      <div className="flex  flex-col w-full items-center mb-[232px]">
        <p className="text-center text-[52px] font-bold mt-[107px]">
          you've won.
        </p>
        <p className="text-center text-[22px] mt-[43px]">
          click through the form to complete your order in the next 5 minutes.
        </p>
        <div className="mt-[29px]">
          <Alarm />
        </div>
      </div>
      <div className="m-[30px]">
        <p className="m-[30px] text-[18px] text-auctionMid text-center">{`${0} people on this page`}</p>
      </div>
    </>
  );
};
